import { useState } from 'react'
import ModerationSettingsTab from '../components/ModerationSettingsTab'
import UserLimitsTab from '../components/UserLimitsTab'
import SpecialMessageTab from '../components/SpecialMessageTab'
import { Settings } from 'lucide-react'

type Tab = 'moderation' | 'limits' | 'special'

export default function SettingsPage() {
  const [activeTab, setActiveTab] = useState<Tab>('moderation')

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h2 className="text-2xl font-bold text-gray-900 flex items-center gap-2">
          <Settings className="w-6 h-6" />
          Ayarlar
        </h2>
      </div>

      {/* Tabs */}
      <div className="border-b border-gray-200">
        <nav className="-mb-px flex space-x-8">
          <button
            onClick={() => setActiveTab('moderation')}
            className={`
              py-4 px-1 border-b-2 font-medium text-sm transition-colors
              ${
                activeTab === 'moderation'
                  ? 'border-primary text-primary'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
              }
            `}
          >
            Moderation Ayarları
          </button>
          <button
            onClick={() => setActiveTab('limits')}
            className={`
              py-4 px-1 border-b-2 font-medium text-sm transition-colors
              ${
                activeTab === 'limits'
                  ? 'border-primary text-primary'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
              }
            `}
          >
            Kullanıcı Limitleri
          </button>
          <button
            onClick={() => setActiveTab('special')}
            className={`
              py-4 px-1 border-b-2 font-medium text-sm transition-colors
              ${
                activeTab === 'special'
                  ? 'border-primary text-primary'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
              }
            `}
          >
            Özel Mesaj
          </button>
        </nav>
      </div>

      {/* Tab Content */}
      <div>
        {activeTab === 'moderation' && <ModerationSettingsTab />}
        {activeTab === 'limits' && <UserLimitsTab />}
        {activeTab === 'special' && <SpecialMessageTab />}
      </div>
    </div>
  )
}
